import { axiosClient, axiosPublic } from './apiClient';
import { AxiosResponse, AxiosError } from 'axios';


interface RegisterResponse {
    result: boolean;
    message: string;
}

interface LoginResponse {
    result: boolean;
    message: string;
    token: string;
}

interface SupplierApplicationResponse {
    result: boolean;
    message: string;
}


// POST FETCHER
export async function postFetcher(
    url: string,
    {
        arg,
    }: {
        arg: any;
    },
) {
    return await axiosClient
        .post(url, arg)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            console.log('postFetcherError: ', error);
            return { error: true, message: error.message };
        });
}

// POST FETCHER GOOGLE FACEBOOK
export async function postFetcherGoogleFacebook(
    url: string,
    {
        arg,
    }: {
        arg: {
            email: string,
            facebookToken: string,
            google: boolean
        };
    },
): Promise<any | string> {
    try {
        const res: AxiosResponse<any> = await axiosPublic.post(url, arg);
        if (res.data.token) {
            const time = new Date();
            time.setDate(time.getDate() + 1);
            localStorage.setItem('access-token', res.data.token);
            localStorage.setItem('expiration-date', time.getTime().toString());
            return res.data;
        } else {
            throw new Error('Token not found in the response');
        }
    } catch (error) {
        console.log('postFetcherError: ', error);
        if (error instanceof Error) {
            return error.message;
        }
        return 'An unknown error occurred';
    }
}

// PUT FETCHER
export async function putFetcher(
    url: string,
    {
        arg,
    }: {
        arg: any;
    },
) {
    try {
        const response = await axiosClient.put(url, arg);
        return response.data;
    } catch (error) {
        console.log('putFetcherError: ', error);
        throw error;
    }
}

// REGISTER FETCHER
export async function postFetcherForRegister(
    url: string,
    {
        arg,
    }: {
        arg: {
            firstName: string;
            lastName: string;
            email: string;
            phoneNumber: string;
            password: string;
            profilePicture: string;
            openAddress: string;
            referenceCode: string;
            companyName: string,
            identityNo: string,
            taxNumber: string,
            taxOffice: string,
            kepAddress: string,
            businessPackageId: string;
            facebookToken?: string,
            city: string,
            district: string,
            status: boolean;
            prk: boolean;
        };
    },
): Promise<RegisterResponse | string> {
    try {
        const res: AxiosResponse<RegisterResponse> = await axiosPublic.post(url, arg);
        if (res.data.result) {
            return res.data;
        } else {
            throw new Error(res.data.message || 'An unknown error occurred');
        }
    } catch (error) {
        if (error instanceof AxiosError) {
            console.log('Axios error response data:', error.response?.data);
            return error.response?.data?.message || 'An unknown error occurred';
        }
        console.log('postFetcherError: ', error);
        if (error instanceof Error) {
            return error.message;
        }
        return 'An unknown error occurred';
    }
}

// LOGIN FETCHER
export async function postFetcherForLogin(
    url: string,
    {
        arg,
    }: {
        arg: {
            email: string;
            password: string;
        };
    },
): Promise<LoginResponse | string> {
    try {
        const res: AxiosResponse<LoginResponse> = await axiosPublic.post(url, arg);
        if (res.data.token) {
            const time = new Date();
            time.setDate(time.getDate() + 1);
            localStorage.setItem('access-token', res.data.token);
            localStorage.setItem('expiration-date', time.getTime().toString());
            return res.data;
        } else {
            throw new Error('Token not found in the response');
        }
    } catch (error) {
        console.log('postFetcherError: ', error);
        if (error instanceof Error) {
            return error.message;
        }
        return 'An unknown error occurred';
    }
}

// REGISTER SUPPLIER APPLICATION
export async function postFetcherForSupplierApplication(
    url: string,
    {
        arg,
    }: {
        arg: {
            fullName: string;
            email: string;
            phoneNumber: string;
            companyTypeId: number;
            supplierProductTypeId: number;
            identityNumber: string;
            city: string;
            district: string;
            marketPlaceName: string;
            taxNumber: string;
            taxOffice: string;
            kepAddress: string;
            mersisNumber: string;
            invoiceType: string;
        };
    },
): Promise<SupplierApplicationResponse | string> {
    try {
        const res: AxiosResponse<SupplierApplicationResponse> = await axiosPublic.post(url, arg);
        if (res.data.result) {
            return res.data;
        } else {
            throw new Error(res.data.message || 'An unknown error occurred');
        }
    } catch (error) {
        if (error instanceof AxiosError) {
            console.log('Axios error response data:', error.response?.data);
            return error.response?.data?.message || 'An unknown error occurred';
        }
        console.log('postFetcherError: ', error);
        if (error instanceof Error) {
            return error.message;
        }
        return 'An unknown error occurred';
    }
}


export const getFetcher = async (url: string) => {
    try {
        const response = await axiosClient.get(url);
        return response.data;
    } catch (error) {
        console.error('Error in getFetcher:', error);
        throw error;
    }
};

export const getFetcherById = async (url: string, id: string) => {
    return await axiosClient.get(`${url}/${id}`).then((res) => res.data);
};

export const getFetcherByIdAndParams = async (
    url: string,
    id: string,
    param: string,
) => {
    return await axiosClient.get(`${url}/${id}/${param}`).then((res) => res.data);
};

export const patchFetcher = (url: string, data: any) =>
    axiosClient.patch(url, data);

export const patchFetcherByIdAndParams = (
    url: string,
    data: any,
    id: string,
    param: string,
) => axiosClient.patch(`${url}/${id}/${param}`, data);

export const deleteFetcher = (url: string) => axiosClient.delete(url);

export const deleteFetcherWithData = async (url: string, data: any) => {
    return await axiosClient
        .delete(url, { data: data })
        .then((res) => res.data)
        .catch((error) => {
            console.log('deleteFetcherWithDataError: ', error);
        });
};

export const postPhotoFetcher = async (url: string, data: any) => {
    return await axiosClient.post(url, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};